import React from "react";
import { Col } from "antd";
function KoCol(props) {
  const { children, span=12 } = props;
  return (<Col span={span}>
    {children}
  </Col>);
}

export default KoCol;